import { render, staticRenderFns } from "./DbSettings.vue?vue&type=template&id=7bace88e&scoped=true&"
import script from "./DbSettings.vue?vue&type=script&lang=js&"
export * from "./DbSettings.vue?vue&type=script&lang=js&"
import style0 from "./DbSettings.vue?vue&type=style&index=0&id=7bace88e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bace88e",
  null
  
)

/* custom blocks */
import block0 from "./DbSettings.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports